// extracted by mini-css-extract-plugin
module.exports = {"container":"TableSortItem_container__3Iv0y","text":"TableSortItem_text__2-FO2","arrow":"TableSortItem_arrow__8blVe","flip":"TableSortItem_flip__2SNWK"};